import { call } from '../functions';
import { CachePool } from './lib/cachePool';
import { CacheDriver, CacheStore, CacheStoreOptions } from './lib/cacheStore';

type CacheStoreFunc = (store: CacheStore) => void;

const INSTANCES = new CachePool();

export const DEFAULT_NAME = 'default';

export function createCache(name: string = DEFAULT_NAME, options: CacheStoreOptions = {}): CacheStore {
    return INSTANCES.newStore(name, {
        driver: CacheDriver.MEMORY,
        ...options,
    });
}

export function cacheStore(name: string = DEFAULT_NAME, func?: CacheStoreFunc): CacheStore {
    const store = INSTANCES.store(name);

    call(func, store);

    return store;
}
